module.exports = __webpack_public_path__ + "img/2012-08-18 13.12.39.85748e73.jpg";